import { SettingConst } from '@faire/web-api--source/types';

/**
 * If enabled, display the modal for retrieval queries
 */
export const SHOULD_DISPLAY_MODAL_QUERIES_FOR_RETRIEVAL =
  'SHOULD_DISPLAY_MODAL_QUERIES_FOR_RETRIEVAL' as SettingConst<
    'SHOULD_DISPLAY_MODAL_QUERIES_FOR_RETRIEVAL',
    boolean,
    'RETAILER' | 'LOGGED_IN_RETAILER' | 'ADMIN' | 'VISITOR_WEB'
  >;
